import type React from 'react';

import type { IconProps} from '@zoomit/icons';
import { Comparison, Moon, Sun } from '@zoomit/icons';

export const themeStates: Record<
  string,
  {
    icon: { (props: IconProps): React.JSX.Element; displayName: string };
    label: string;
  }
> = {
  light: {
    icon: Sun,
    label: 'حالت روز',
  },
  system: {
    icon: Comparison,
    label: 'حالت خودکار',
  },
  dark: {
    icon: Moon,
    label: 'حالت شب',
  },
};
